
<nav id="week-selector">
  <agendas-week-selector [date]="currentDate"
                         [beforeDateChangeHook$]="canChangeDate$.bind(this)"></agendas-week-selector>
</nav>

<div class="spinner-container" *ngIf="loading$ | async">
  <mat-spinner [diameter]="36" class="loading"></mat-spinner>
</div>

<span *ngIf="!(hasData$ | async) && !(loading$ | async)" class="empty-list">
        {{ 'message.no_session_for_this_week' | translate }}
    </span>

<div class="week-comment" *ngIf="this.weekComment">
  <p class="comment-header">{{ 'title.week_comment' | translate }}</p>
  {{ this.weekComment }}
</div>

<ul>
  <li *ngFor="let timeslot of timeslots | keyvalue">
    <div class="diary-week day-{{ timeslot.key|appDate:'yyyy-M-d'  }}">
      <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="60px" fxShrink="0" fxGrow="0" style="flex: 0 0 60px;">
          <div class="date">
            <span class="week-day">{{ timeslot.key|appDate:'EEE' :'' : locale }}</span>
            <span class="month">{{ timeslot.key|appDate:'dd LLL' :'' : locale}}</span>
          </div>
        </div>
        <div fxFlex="100">
          <ul>
            <li *ngFor="let data of timeslot.value" (click)="onSessionClicked(data)">
              <app-mobile-diary-list-section [content]="data"></app-mobile-diary-list-section>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
</ul>
